export default "__VITE_ASSET__C3h9mibm__"